import { render, staticRenderFns } from "./DatatableList.vue?vue&type=template&id=61da2f40&"
import script from "./DatatableList.vue?vue&type=script&lang=js&"
export * from "./DatatableList.vue?vue&type=script&lang=js&"
import style0 from "./DatatableList.vue?vue&type=style&index=0&id=61da2f40&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports